import React from 'react';

import Link from 'next/link';

import { useNavigate } from 'hooks/useNavigation';

import { Button } from '@components/Button';
import { TextGroup } from '@components/TextGroup';

import { SuccessMessageWrapper } from './styles';

interface SuccessMessageProps {
  label: string;
  header: string;
  paragraph: string;
  buttonText: string;
  buttonVariant?: 'primary' | 'secondary';
  link?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

/**
 * Renders a success message in auth pages.
 */

export function SuccessMessage({
  label,
  header,
  paragraph,
  buttonText,
  buttonVariant,
  link,
  type,
}: SuccessMessageProps): JSX.Element {
  const { goToPath } = useNavigate();

  const handleClick = () => {
    if (link) {
      goToPath(link);
    }
  };

  return (
    <SuccessMessageWrapper>
      <TextGroup label={label} header={header} paragraph={paragraph} />
      {link ? (
        <Link href={link}>
          <Button type={type} label={buttonText} onClick={handleClick} variant={buttonVariant} />
        </Link>
      ) : (
        <Button type={type} label={buttonText} onClick={handleClick} variant={buttonVariant} />
      )}
    </SuccessMessageWrapper>
  );
}
